import React from 'react';
import { Props } from './interfaces';
import './MenuTop.scss';
import './MenuTop-media.scss';
import LinkMenu from '../LinkMenu/LinkMenu';
import LinkHashMenu from '../LinkHashMenu/LinkHashMenu';

const MenuTop = ({ menu, onClickLink }: Props) => {
  return (
    <menu className="menu-top">
      {menu.map((menu, i) => {
        if (menu.hash) {
          return <LinkHashMenu menu={menu} onClickLink={onClickLink} key={i} />;
        }
        return <LinkMenu menu={menu} onClickLink={onClickLink} key={i} />;
      })}
    </menu>
  );
};

export default MenuTop;
